import { Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { AppSettings } from './AppSettings';
import { Footer } from './Footer';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useNavigation } from './useNavigation';

/**
 * The chrome around every routed page — the React equivalent of
 * `_VerticalLayout.cshtml`.
 *
 * The nesting is load-bearing: `.app-wrap > .app-header + .app-sidebar +
 * main.app-body > .app-content > .content-wrapper` is exactly what the `set-*`
 * layout classes select on, and the footer sits inside `main`, after
 * `.app-content`, not after it. `@RenderSection("modelBlock")` has no analogue —
 * a React page renders its own modals wherever it likes.
 *
 * `_AppDrawer.cshtml` is not ported. It is a virtual-assistant demo with
 * hardcoded conversation text and no backend, and its opener is commented out in
 * the header, so it is unreachable in the shipped app.
 *
 * `AppSettings` is ported because it is the only UI for the layout classes and
 * colour themes, but its header opener stays commented out as it is today; the
 * drawer is reached by calling `toggleSettings()` from the layout context.
 */
export function AppShell() {
  const { isAuthenticated } = useAuth();
  const { data: menuItems } = useNavigation();

  return (
    <div className="app-wrap">
      <Header />

      {/* The Razor layout renders the sidebar unconditionally — the
          `if (isAuthenticated)` around it is commented out — but the navigation
          endpoint is authenticated, so for a guest there is nothing to draw. */}
      {isAuthenticated && <Sidebar items={menuItems ?? []} />}

      <main className="app-body">
        <div className="app-content">
          <div className="content-wrapper">
            <Outlet />
          </div>
        </div>

        <Footer />
      </main>

      {isAuthenticated && <AppSettings />}
    </div>
  );
}
